export {};

//import 'sticky-sidebar/dist/jquery.sticky-sidebar.js';
import 'sticky-sidebar/dist/sticky-sidebar.js';

//
const $document = $(document);
const $window = $(window);

let sidebar = document.querySelector('.layout__aside');
if (sidebar === undefined || sidebar === null) {
    // no sidebar on the page
} else {
    const nanoContentEl = $(sidebar).find('.nano-content');
    nanoContentEl.css('position', 'absolute');

    // else
    window.stickySidebar = new StickySidebar(sidebar, {
        topSpacing: 60,
        bottomSpacing: 30,
        containerSelector: '.layout',
        innerWrapperSelector: '.layout__aside-inner',
    });
}

window.updateStickySidebarPosition = () => {
    sidebar = document.querySelector('.layout__aside');
    updateStickySidebar(sidebar);
};

function updateStickySidebar(element) {
    if (element === undefined || element === null) {
        // no sidebar on the page
    } else {
        window.stickySidebar ? window.stickySidebar.destroy() : '';
        window.stickySidebar = new StickySidebar(element, {
            topSpacing: 60,
            bottomSpacing: 30,
            containerSelector: '.layout',
            innerWrapperSelector: '.layout__aside-inner',
        });

        // fix for cancel print in Chrome
        if ($(element).height() <= 0) {
            setTimeout(() => {
                scrollBlock();
            }, 1500);
        }
    }
}

$('.js-nano').nanoScroller({
    alwaysVisible: true,
});

let lastScroll = 0;
let diffScroll = 0;
let sumScroll = 0;
let timeoutId = null;

let scrollBlock = function() {
    const $layout = $('.layout');
    let $summaryFloating = $('.layout__aside-inner');
    let $summaryWrap = $('.layout__aside');
    let $sideLi = $('.side-nav > li');
    const $sideNav = $('.side-nav');

    changeCatcherHeight();
    //changeBlockPosition();

    $(document).on('scroll', function(evt) {
        //changeBlockPosition(evt);
    });

    $(document).on('click', '.accordion__header', function onClick(evt) {
        setTimeout(function() {
            //changeBlockPosition();
        }, 301);
    });

    function changeBlockPosition(evtScroll) {
        if (evtScroll) {
            clearTimeout(timeoutId);
            let newScroll = $document.scrollTop();
            diffScroll = newScroll - lastScroll;
            lastScroll = newScroll;
        }

        if ($summaryFloating.length > 0) {
            let TOP_DISTANCE = 67; // расстояние, чтобы фиксированный хэдер не перекрывал сайдбар

            if (window.innerWidth >= 768 && $document.scrollTop() > $summaryWrap.offset().top - TOP_DISTANCE) {
                $summaryFloating.css({
                    bottom: 'auto',
                    position: 'fixed',
                });
                // фиксация top позиции side nav если до скролили до конца aside
                //if ($sideNav.offset().top + $sideNav.height() > $layout.offset().top + $layout.height()) {
                if ($sideNav.height() + lastScroll > $layout.offset().top + $layout.height()) {
                    sumScroll += diffScroll;
                    const top = `${TOP_DISTANCE - sumScroll}px`;
                    $summaryFloating.css({ top });

                    //Лечим баг на Ipad накладывание сайдбара на футер при быстрой прокрутки
                    // if (Modernizr.ipad) {
                    //     timeoutId = setTimeout(() => $summaryFloating.css({ top }), 1000);
                    // }
                } else {
                    sumScroll = 0;
                    $summaryFloating.css({
                        top: TOP_DISTANCE + 'px',
                    });
                }
            } else {
                $summaryFloating.css({
                    top: 0,
                    bottom: 'auto',
                    position: 'absolute',
                });
            }
        }
    }
    //Лечим баг на Ipad накладывание сайдбара на футер при быстрой прокрутки
    // setInterval(function() {
    //     changeBlockPosition();
    // }, 1000);

    function changeCatcherHeight() {
        let heightList = 0;
        $sideLi.each(function() {
            const $li = $(this);
            heightList += $li.outerHeight();
        });
        $summaryFloating.css('height', heightList);

        if (window.innerWidth >= 768) {
            $summaryWrap.css('height', $summaryFloating.outerHeight());
            //$summaryWrap.css('min-height', heightList);
        } else {
            $summaryWrap.css('height', 0);
        }
    }
};

scrollBlock();

// check height of document
let documentHeight = $document.height();

function checkDocumentHeight() {
    const currentDocumentHeight = $document.height();

    if (currentDocumentHeight !== documentHeight) {
        documentHeight = currentDocumentHeight;
        updateStickySidebarPosition();
    }
    setTimeout(checkDocumentHeight, 800);
}

setTimeout(checkDocumentHeight, 800);



// WEBPACK FOOTER //
// ./js/main/module/nanoscroller.js